import { MY_ORDERS } from '../ids';
import { InstallLocation } from '../types';
import { formatDescription } from '../utils';
export const ids = MY_ORDERS;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Standalone,
    social: false,
    showInLoginMenu: true,
    method: 'addSection',
    urlOverride: 'my-orders',
    page: {
        name: t('memberPages.addModal.memberPagesTab.orders.title'),
        shortDescription: t('memberPages.addModal.memberPagesTab.orders.body'),
        description: formatDescription({
            text: t('memberPages.addModal.memberPagesTab.orders.description.body'),
            bulletPoints: [
                t('memberPages.addModal.memberPagesTab.orders.description.bullet1'),
                t('memberPages.addModal.memberPagesTab.orders.description.bullet2'),
            ],
        }),
        origin: t('memberPages.addModal.memberPagesTab.by.stores.label'),
        iconURL: `${staticsUrl}assets/images/icons/stores-icon.png`,
        screenshots: [
            `${staticsUrl}assets/images/my-orders/my-orders.png`,
            `${staticsUrl}assets/images/my-orders/my-orders-2.png`,
        ],
    },
});
//# sourceMappingURL=my-orders.js.map